module.exports = __webpack_public_path__ + "static/media/user-guide-1.2173fd44.png";